import React from 'react';
import PropTypes from 'prop-types';
import {
  Panel,
  Table,
} from 'react-bootstrap';

import './TicketNumberList.css';
import { toCentralTimeDisplayDate } from '../../../utils';

/* eslint-disable */
const proptypes = {
  allTicketNumbers: PropTypes.array.isRequired,
  setTicketNumberObjectAction: PropTypes.func.isRequired,
  selectedTicketNumberId: PropTypes.number,
};
/* eslint-enable */

const TicketList = (props) => {
  const { allTicketNumbers, setTicketNumberObjectAction, selectedTicketNumberId } = props;

  const renderRow = (rowData) => {
    const isActiveStyle = (rowData.id === selectedTicketNumberId)
      ? { backgroundColor: '#337ab7', color: '#fff', cursor: 'pointer' }
      : { cursor: 'pointer' };

    const tzDate = toCentralTimeDisplayDate(rowData.created_at.iso8601);
    const hasTime = rowData.totalManHours.totalSeconds > 0;
    return (
      <tr
        key={rowData.id}
        style={isActiveStyle}
        onClick={() => { setTicketNumberObjectAction(rowData); }}
      >
        <td>
          {tzDate}
        </td>
        <td>
          {rowData.created_by.fullname}
        </td>
        <td>
          {rowData.number}
        </td>
        <td>
          {hasTime && rowData.totalManHours.to_string}
        </td>
      </tr>
    );
  };

  return (
    <React.Fragment>
      <Panel className="ticket-number-list">
        <Table responsive>
          <thead>
            <tr>
              <th>Date Created</th>
              <th>Created By </th>
              <th>Ticket Number</th>
              <th>Total Man Hours</th>
            </tr>
          </thead>
          <tbody>
            {allTicketNumbers.map((rowData) => {
              return (
                renderRow(rowData)
              );
            })}
          </tbody>
        </Table>
      </Panel>
    </React.Fragment>
  );
};

TicketList.propTypes = proptypes;

export default (TicketList);
